package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2023_08_18_Day_3() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The wind picks up, and as the clouds dissipate, the peaks of the two mountains, in whose valley the heroes are currently traveling, come into view. At the end of the day, Bigglesworth sees something very large flying far away (1-2 miles). It has wings, a head, and a lizard-like tail. Our heroes continue briefly before setting up camp for the night. During the 3rd watch, Goram sees a heard of sheep and shots one with his bow.")
    }
}
